module.exports = __webpack_public_path__ + "static/img/hane_icon.c15ed36c.jpg";